import React, { useState } from "react"
import "./WorldMap.css"
import MapRenderer from "./MapRenderer"
import RegionsNavigation from "./RegionsNavigation"
import Tooltip from "../Tooltip"

const WorldMap = ({
  position,
  setPosition,
  selectedRegion,
  selectRegion,
  resetView,
  handleMoveEnd,

  setHoverCountry,
  setHoverRegion,
  hoveredRegion,
  countryToRegion,
  availableCountries,
  regionsMap,
  onCountryClick,
}) => {

  const [tooltip, setTooltip] = useState({ visible: false })

  return (
    <div className="world-map-root">
      <RegionsNavigation
        regions={regionsMap}
        onSelect={selectRegion}
        onReset={resetView}
        selectedRegion={selectedRegion}
      />

      <div className="world-map-stage">
        <MapRenderer
          position={position}
          setPosition={setPosition}
          selectedRegion={selectedRegion}
          setTooltip={setTooltip}
          setHoverCountry={setHoverCountry}
          selectRegion={selectRegion}
          handleMoveEnd={handleMoveEnd}
          hoveredRegion={hoveredRegion}
          setHoverRegion={setHoverRegion}
          countryToRegion={countryToRegion}
          availableCountries={availableCountries}
          regionsMap={regionsMap}
          onCountryClick={onCountryClick}
        />
      </div>

      <Tooltip tooltip={tooltip} />
    </div>
  )
}

export default WorldMap
